export function isClient() {
  return typeof window !== 'undefined' && typeof window.document !== 'undefined';
}

export default isClient;
